import { render, staticRenderFns } from "./NavIconLinks.vue?vue&type=template&id=36988b52&scoped=true&"
import script from "./NavIconLinks.vue?vue&type=script&lang=js&"
export * from "./NavIconLinks.vue?vue&type=script&lang=js&"
import style0 from "./NavIconLinks.vue?vue&type=style&index=0&id=36988b52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36988b52",
  null
  
)

export default component.exports